const adminRoutes = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/dashboard/Dashboard.vue'),
    meta: { user: ['Administrator', 'Merchant'] }
  },
  {
    path: '/transactions/transaction-history',
    name: 'Transaction History',
    component: () => import('@/views/dashboard/admin/TransactionHistory.vue'),
    meta: { user: 'Administrator' }
  },
  {
    path: '/transactions/transaction-reports',
    name: 'Transaction Reports',
    component: () => import('@/views/dashboard/admin/transactions/TransactionReport.vue'),
    meta: { user: 'Administrator' }
  },
  {
    path: '/transactions/transaction-repost-approval',
    name: 'Transaction Repost Approval',
    component: () => import('@/views/dashboard/admin/transactions/TransactionRepostApproval.vue'),
    meta: { user: 'Administrator' }
  },
  {
    path: '/audit-trail',
    name: 'Audit Trail',
    component: () => import('@/views/dashboard/admin/AuditTrail.vue'),
    meta: { user: 'Administrator' }
  },
  {
    path: '/users/admin-users',
    name: 'Admin Users',
    component: () => import('@/views/dashboard/admin/users/adminUsers.vue'),
    meta: { user: 'Administrator' }
  },
  {
    path: '/manage-merchants/merchants',
    name: 'Merchants',
    component: () => import('@/views/dashboard/admin/manage-merchants/Merchants.vue'),
    meta: { user: 'Administrator' }
  },
  {
    path: '/manage-merchants/api-merchants',
    name: 'API Merchants',
    component: () => import('@/views/dashboard/admin/manage-merchants/APIMerchants.vue'),
    meta: { user: 'Administrator' }
  },
  {
    path: '/billing-accounts',
    name: 'Billing Accounts',
    component: () => import('@/views/dashboard/admin/billing_accounts/BillingAccounts.vue'),
    meta: { user: 'Administrator' }
  },
  {
    path: '/users/assign-user-department',
    name: 'User Departments',
    component: () => import('@/views/dashboard/admin/users/assignUserDepartments.vue'),
    meta: { user: 'Administrator' }
  },
  {
    path: '/users/assign-user-privilege',
    name: 'User Priviledge',
    component: () => import('@/views/dashboard/admin/users/assignUserPrivilege.vue'),
    meta: { user: 'Administrator' }
  },
  {
    path: '/settings/bank-registration',
    name: 'Bank Registration',
    component: () => import('@/views/dashboard/admin/settings/BankRegistration.vue'),
    meta: { user: 'Administrator' }
  },
  {
    path: '/settings/transaction-charge-management',
    name: 'Transaction Charge Management',
    component: () => import('@/views/dashboard/admin/settings/TransactionChargeManagement.vue'),
    meta: { user: 'Administrator' }
  },
  {
    path: '/settings/transaction-processor-management',
    name: 'Transaction Processor Management',
    component: () => import('@/views/dashboard/admin/settings/TransactionProcessorManagement.vue'),
    meta: { user: 'Administrator' }
  },
  {
    path: '/settings/department-registration',
    name: 'Department Registration',
    component: () => import('@/views/dashboard/admin/settings/DepartmentRegistration.vue'),
    meta: { user: 'Administrator' }
  },
  {
    path: '/settings/assign-department-operation',
    name: 'Assign Department Operation',
    component: () => import('@/views/dashboard/admin/settings/AssignDepartmentOperation.vue'),
    meta: { user: 'Administrator' }
  }
]

export default adminRoutes
